import axios from 'axios';

export const camposRegistroViajero = ['nombre', 'primer_apellido', 'segundo_apellido', 'sexo', 'fecha_nacimiento',
  'tipo_documento', 'numero_documento', 'soporte_documento', 'telefono_fijo', 'telefono_movil', 'email',
  'direccion', 'poblacion', 'provincia', 'codigo_postal', 'nacionalidad', 'parentesco'];

export async function obtenerRegistroViajero(hash) {
  const response = await axios.get(`/registros-viajeros/${encodeURIComponent(hash)}`);
  return response.data.data;
}

export async function completarRegistroViajero(hash, version, formulario) {
  const datos = { version_pasajero: version };
  camposRegistroViajero.forEach(campo => { if (campo in formulario) datos[campo] = formulario[campo]; });
  const response = await axios.post(`/registros-viajeros/${encodeURIComponent(hash)}`, datos);
  return response.data;
}
